( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'LotMinDTOCustomService', LotMinDTOCustomService );

    LotMinDTOCustomService.$inject = ['$http', '$q'];

    function LotMinDTOCustomService($http, $q) {
        var service = {
            getAllByShipmentId: getAllByShipmentId,
            returnLotMinDTOByStatus: returnLotMinDTOByStatus,
            returnNoSiLotsByPurchContract : returnNoSiLotsByPurchContract
        };

        return service;

        function getAllByShipmentId(id) {
            var url = "api/lotMinDTO/shipments/" + id;
            return $http.get(url);
        }
        function returnLotMinDTOByStatus( status ) {
            var url = "api/lotMinDTO/status/" + status;
            return $http.get( url );
        }

        function returnNoSiLotsByPurchContract( id ) {
            var url = "api/lotMinDTO/purchContract/" + id + "/shipment/null";
            return $http.get( url );
        }

    }

})();
